import { combineReducers } from 'redux'

import metadataReducer from './metadata-reducer'
import usersReducer from './users-reducer'

const commonCombinedReducer = combineReducers({
  metadata: metadataReducer,
  users: usersReducer,
})

export default commonCombinedReducer
